var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('LoadRecent',{ref:"loadRecent",staticClass:"my-10"}),_c('List',{staticClass:"my-10",on:{"refresh":_vm.refresh}}),_c('EditBasic'),_c('EditPhone'),_c('EditEmail')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }